import {SectionTypeVo} from '../../common/shared/api/karina/vo/enums/SectionTypeVo.enum';
import {SectionType} from '../generated/types';

export function createSectionType(sectionTypeVo: SectionTypeVo): SectionType {
  return map[sectionTypeVo] || SectionType.Unknown;
}

const map: {[key in SectionTypeVo]: SectionType} = {
  [SectionTypeVo.Top]: SectionType.Top,
  [SectionTypeVo.TopV2]: SectionType.Top,
  [SectionTypeVo.PromotionBanner]: SectionType.PromotionBanner,
  [SectionTypeVo.LineBanner]: SectionType.LineBanner,
  [SectionTypeVo.CardBanner]: SectionType.CardBanner,
  [SectionTypeVo.Theme]: SectionType.Theme,
  [SectionTypeVo.ScrollTheme]: SectionType.ScrollTheme,
  [SectionTypeVo.Episode]: SectionType.Episode,
  [SectionTypeVo.UpdateAlarm]: SectionType.Updatealarm,
  [SectionTypeVo.BigBanner]: SectionType.BigBanner,
  [SectionTypeVo.RecentViewed]: SectionType.RecentViewed,
  [SectionTypeVo.DayOfWeek]: SectionType.DayOfWeek,
  [SectionTypeVo.Ranking]: SectionType.Ranking,
  [SectionTypeVo.RankingV2]: SectionType.RankingV2,
  [SectionTypeVo.MainRanking]: SectionType.MainRanking,
  [SectionTypeVo.UserBasedRecommend]: SectionType.UserBasedRecommend,
  [SectionTypeVo.SeriesBasedRecommend]: SectionType.SeriesBasedRecommend,
  [SectionTypeVo.New]: SectionType.New,
  [SectionTypeVo.Event]: SectionType.Event,
  [SectionTypeVo.RecommendEvent]: SectionType.RecommendEvent,
  [SectionTypeVo.CashfriendsAd]: SectionType.CashfriendsAd,
  [SectionTypeVo.HelixTheme]: SectionType.HelixTheme,
  [SectionTypeVo.RankingTheme]: SectionType.RankingTheme,
};
